import React from "react";
import { withRouter } from "react-router";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import { ISSUING_STATUS } from "../constants";

import { IssuingApprovedBalance } from "./IssuingApprovedBalance";
import IssuingApprovedCard from "./IssuingApprovedCard";
import { IssuingApprovedAddFunds } from "./IssuingApprovedAddFunds";
import IssuingApprovedTransactions from "./IssuingApprovedTransactions";

const IssuingApproved = ({ userIssuingStatus }) => {
  const { accountId, cardId, status } = userIssuingStatus;

  if (!accountId || status !== ISSUING_STATUS.APPROVED) {
    // TODO
    return "You are not approved.";
  }

  const stripe = loadStripe(process.env.REACT_APP_STRIPE_ISSUING_PUBLIC_KEY, { stripeAccount: accountId });

  return (
    <Elements stripe={stripe} >
      <div>
        <div className="flex flex-col space-y-4">
          <div className="flex flex-col md:flex-row justify-between space-y-4 md:space-y-0 md:space-x-4">
            <IssuingApprovedBalance />
            <IssuingApprovedCard cardId={cardId} />
            <IssuingApprovedAddFunds />
          </div>
          <IssuingApprovedTransactions />
        </div>
      </div>
    </Elements>
  );
};

export default withRouter(IssuingApproved);
